import axios from 'axios'

/**
 * @desc Fetches all Banner Groups
 */
export const fetchAllBannerGroups = () =>
  axios.get('/authenticated/banner-groups').then((res) => res.data)
